module.exports = __webpack_public_path__ + "static/grell-e922aa23260a3b1a6cb0753b78b86626.jpg";